import { useEffect, useState } from 'react';
import { 
    Button, 
    ResourceContextProvider, 
    // useDataProvider,
    useNotify,
    useSaveContext
} from 'react-admin';
import { useWizardFormContext, WizardForm } from '@react-admin/ra-form-layout';
import {
    Alert,
    Box,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Container,
    FormControlLabel, 
    FormGroup,
    Typography
} from '@mui/material';
import { useFormState } from 'react-hook-form';

import CheckCircle from "@mui/icons-material/CheckCircle";
import Close from "@mui/icons-material/Close";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import PreinstallationChecklistLink from "./TransactionCollectorSetup-PreinstallationChecklistLink.png";
import { API_ROOT } from "transport-layer";
import PublishIcon from '@mui/icons-material/Publish';

const Step1 = ({
        acceptedEula,
        setAcceptedEula,
    }) => {

    return (
        <Box sx={{ backgroundColor:"white", padding: 3 }}>
            <h2>Please accept to proceed:</h2>

            <Typography sx={{
                maxHeight: "50vh",         // Limit height
                overflowY: 'auto',      // Enable vertical scroll
                paddingRight: 2,        // Optional: spacing for scrollbar
            }}>
                <h2>GENERAL TERMS AND CONDITIONS</h2>

                <p>______________________________________________________________</p>

                <p>1.	Applicability. These general terms and conditions (these "Terms") are the only terms that govern the provision of the OnPoint Solution and related services (collectively, the "Services") by OnPoint Data Services, LLC ("OnPoint") to the customer named on the accompanying order confirmation or other relevant document or webpage ("Customer"). The accompanying order confirmation or other relevant document or webpage (the "Order Confirmation") and these Terms (collectively, this "Agreement") comprise the entire agreement between the parties, and supersede all prior and contemporaneous understandings, agreements, negotiations, representations and warranties, and communications, both written and oral. In the event of any conflict between these Terms and the Order Confirmation, these Terms shall govern, unless the Order Confirmation expressly states that the terms and conditions of the Order Confirmation shall control. These Terms prevail over any of Customer's general terms and conditions regardless whether or when Customer has submitted its request for proposal, order, or such terms. Provision of Services to Customer does not constitute acceptance of any of Customer's terms and conditions and does not serve to modify or amend these Terms. By signing or otherwise indicating assent to these Terms and/or the Order Confirmation, the person doing so represents and warrants to OnPoint that such person has full right and authority to sign such Terms and/or Order Confirmation on behalf of Customer and to bind Customer to same.</p>

                <p>2.	Services. OnPoint shall provide the Services to Customer as described in the Order Confirmation in accordance with these Terms. Customer acknowledges and agrees that the Services shall include the installation by OnPoint of software onto Customer's point of sale and/or IT systems. OnPoint shall use reasonable efforts to meet any performance dates specified in the Order Confirmation, and any such dates shall be estimates only.</p>

                <p>3.	Customer's Obligations. Customer shall: (a) cooperate with OnPoint in all matters relating to the Services and provide such access to Customer's premises, computers, point of sale and IT systems, equipment, and office accommodation and other facilities as may reasonably be requested by OnPoint, for the purposes of performing the Services; (b) respond promptly to any OnPoint request to provide direction, information, approvals, authorizations, or decisions that are reasonably necessary for OnPoint to perform Services in accordance with the requirements of this Agreement; (c) provide such Customer materials or information as OnPoint may reasonably request to carry out the Services in a timely manner and ensure that such Customer materials or information are complete and accurate in all material respects; (d) comply with all third party contracts; and (e) obtain and maintain all necessary licenses and consents and comply with all applicable laws in relation to the Services. Without limiting the foregoing, center store promotion participants agree to report data to OnPoint in a timely manner or risk forfeiture of promotional reimbursements, at OnPoint's sole discretion; it being understood that such data must be submitted to OnPoint no later than fourteen (14) calendar days after the end of each month in order for Customer to be eligible for reimbursement for center store promotions. If OnPoint's performance of its obligations under this Agreement is prevented or delayed by any act or omission of Customer or its agents, subcontractors, consultants, or employees, OnPoint shall not be deemed in breach of its obligations under this Agreement or otherwise liable for any costs, charges, or losses sustained or incurred by Customer, in each case, to the extent arising directly or indirectly from such prevention or delay.</p>

                <p>4.	Change Orders. If either party wishes to change the scope or performance of the Services, it shall submit details of the requested change to the other party in writing. OnPoint shall, within a reasonable time after such request, provide a written estimate to Customer of: (a) the likely time required to implement the change; (b) any necessary variations to the fees and other charges for the Services arising from the change; (c) the likely effect of the change on the Services; and (d) any other impact the change might have on the performance of this Agreement. Promptly after receipt of the written estimate, the parties shall negotiate the terms of such change (a "Change Order"). Neither party shall be bound by any Change Order unless mutually agreed upon in writing in accordance with Section 15. Notwithstanding the foregoing, OnPoint may, from time to time change the Services without the consent of Customer provided that such changes do not materially and adversely affect the nature or scope of the Services, or the fees or any performance dates set forth in the Order Confirmation.</p>

                <p>5.	Payment. Customer shall pay the fees set forth in the Order Confirmation. Customer shall pay all invoiced amounts due to OnPoint within fifteen (15) days from the date of OnPoint's invoice, unless otherwise set forth in the Order Confirmation. Customer shall make all payments hereunder in US dollars. In the event payments are not received by OnPoint within fifteen (15) days after becoming due, OnPoint may: (a) charge interest on any such unpaid amounts at a rate of 2% per month or, if lower, the maximum amount permitted under applicable law, from the date such payment was due until the date paid; and (b) suspend performance for all Services until payment has been made in full. Customer shall be responsible for all taxes, duties and charges of any kind imposed by any federal, state, or local governmental entity on any amounts payable by Customer hereunder.</p>

                <p>6.	Intellectual Property.</p>

                <p>(a)	All intellectual property rights, including copyrights, patents, patent disclosures and inventions (whether patentable or not), trademarks, service marks, trade secrets, know-how and other confidential information, trade dress, trade names, logos, corporate names, and domain names, together with all of the goodwill associated therewith, derivative works and all other rights (collectively, "Intellectual Property Rights") in and to all documents, software, services, work product, and other materials that are delivered to Customer under this Agreement or prepared by or on behalf of OnPoint in the course of performing the Services, including the OnPoint Solution (collectively, the "Deliverables"), shall be owned by OnPoint. OnPoint hereby grants Customer a license to use all such Intellectual Property Rights on a non-exclusive, non-transferable, non-sublicensable, fully paid-up, and royalty-free, basis to the extent incorporated in, and necessary to enable Customer to make reasonable use of, the Deliverables and the Services.</p>

                <p>(b)	Customer shall not use OnPoint's Intellectual Property Rights for any purposes beyond the scope of the access granted in this Agreement. Without limiting the foregoing, Customer shall not at any time, directly or indirectly, and shall not permit any related person or entity to: (i) copy, modify, or create derivative works of any of the Services or Deliverables, in whole or in part; (ii) rent, lease, lend, sell, license, sublicense, assign, distribute, publish, transfer, or otherwise make available any of the Services or Deliverables, including on or in connection with the internet or any time-sharing, service bureau, software as a service, cloud, or other technology or service; (iii) reverse engineer, disassemble, decompile, decode, adapt, or otherwise attempt to derive or gain access to any software component of the Services or Deliverables, in whole or in part; (iv) bypass or breach any security device or protection used by any of the Services or Deliverables; (v) input, upload, transmit, or otherwise provide to or through the Services or the Deliverables any information or materials that are unlawful or injurious, or contain, transmit, or activate any harmful code, viruses or the like; (vi) damage, destroy, disrupt, disable, impair, interfere with, or otherwise impede or harm in any manner the Services or the Deliverables or OnPoint's provision of services to any third party, in whole or in part; (vii) remove any proprietary notices from any Deliverables; (viii) use the Services or the Deliverables in any manner or for any purpose that infringes, misappropriates, or otherwise violates any intellectual property right or other right of any person or entity or that violates any applicable law; or (ix) access or use any of the Services or the Deliverables for purpose of competitive analysis of the Services or Deliverables or for the development or provision of a competing solution. OnPoint reserves all rights not expressly granted to Customer in this Agreement. Except for the limited rights and licenses expressly granted under this Agreement, nothing in this Agreement grants, by implication, waiver, estoppel, or otherwise, to Customer or any third party any intellectual property rights or other right, title, or interest in or to any Deliverables or Services.</p>

                <p>(c)	Notwithstanding anything to the contrary in this Agreement, OnPoint may, directly or indirectly (including through the use of related entities, contractors and other third parties (collectively, "Related Entities") collect, compile and analyze data and information relating to the use of the Deliverables and/or Services by or through Customer, including, without limitation, transaction data (collectively, "Data"), provided, however, that, except as set forth below with respect to Anonymous Aggregated Data, OnPoint may only disclose and sell the Data to its Related Entities, to manufacturers that participate in OnPoint promotions and to Customer's OnPoint Distributor. Without limiting the foregoing, Customer agrees that OnPoint may: (i) make Anonymous Aggregated Data publicly available in compliance with applicable law, (ii) use, disclose, and sell Anonymous Aggregated Data to the extent and in the manner permitted under applicable law; and (iii) prepare reports, studies, analyses and other work product in connection with the Anonymous Aggregated Data; it being understood that all right, title, and interest in such reports, studies, analyses and other work product, and all intellectual property rights therein, belong to and are retained solely by OnPoint. For purposes of the foregoing, "Anonymous Aggregated Data" means Data that is used by OnPoint in an aggregate and anonymized manner.</p>

                <p>(d)	If Customer or any of its personnel sends or transmits any communications or materials to OnPoint suggesting or recommending changes to the Services or the Deliverables, including, without limitation, new features or functionality relating thereto, or any comments, questions, suggestions, or the like ("Feedback"), OnPoint is free to use such Feedback irrespective of any other obligation or limitation between the parties governing such Feedback. OnPoint is free to use, without any attribution or compensation to any party, any ideas, know-how, concepts, techniques, or other intellectual property rights contained in the Feedback, for any purpose whatsoever, although OnPoint is not required to use any Feedback.</p>

                <p>7.	Confidential Information. All non-public, confidential or proprietary information of a party (as the "Disclosing Party"), including, but not limited to, trade secrets, technology, information pertaining to business operations and strategies, and information pertaining to customers, pricing, and marketing (collectively, "Confidential Information"), disclosed by the Disclosing Party to the other party (as the "Receiving Party"), whether disclosed orally or disclosed or accessed in written, electronic or other form or media, and whether or not marked, designated or otherwise identified as "confidential," in connection with the provision or receipt of the Services and this Agreement is confidential, and shall not be disclosed or copied by the Receiving Party without the prior written consent of the Disclosing Party. Notwithstanding the foregoing, the Receiving Party shall be permitted to disclose the Disclosing Party's Confidential Information to affiliates, contractors, agents, representatives and other personnel with a need to know who are bound by confidentiality obligations no less stringent than those contained herein. Customer agrees to use OnPoint's Confidential Information only to make use of the Services and Deliverables as contemplated herein. "Confidential Information" shall not include information that is or becomes publicly available, information that is independently developed by the Receiving Party without reference to or use of the Disclosing Party's Confidential Information, information that is received by the Receiving Party by a third party without obligation of confidentiality, information required to be disclosed by applicable law, or, with respect to OnPoint's confidentiality obligations, Anonymous Aggregated Statistics.</p>

                <p>8.	Representation and Warranty. OnPoint represents and warrants to Customer that it shall perform the Services in a professional and workmanlike manner. OnPoint shall not be liable for a breach of the warranty set forth in this Section unless Customer gives written notice of the defective Services, reasonably described, to OnPoint within ten (10) days of the time when Customer discovers or ought to have discovered that the Services were defective. OnPoint shall, in its sole discretion, either: (a) repair or re-perform such Services; or (b) credit or refund the price of such Services at the pro rata contract rate. THE REMEDIES SET FORTH IN THIS SECTION SHALL BE THE CUSTOMER'S SOLE AND EXCLUSIVE REMEDY AND ONPOINT'S ENTIRE LIABILITY FOR ANY BREACH OF THE LIMITED WARRANTY SET FORTH IN THIS SECTION.</p>

                <p>9.	Disclaimer of Warranties. EXCEPT FOR THE WARRANTY SET FORTH IN SECTION 8 ABOVE, ONPOINT MAKES NO WARRANTY WHATSOEVER WITH RESPECT TO THE SERVICES OR DELIVERABLES, INCLUDING ANY (A) WARRANTY OF MERCHANTABILITY; (B) WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE; (C) WARRANTY OF TITLE; OR (D) WARRANTY AGAINST INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS OF A THIRD PARTY; WHETHER EXPRESS OR IMPLIED BY LAW, COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OF TRADE, OR OTHERWISE.</p>

                <p>10.	Limitation of Liability. IN NO EVENT SHALL ONPOINT BE LIABLE TO CUSTOMER OR TO ANY THIRD PARTY FOR ANY DAMAGES ARISING OUT OF OR RELATED TO THIRD-PARTY SOFTWARE, HARDWARE OR OTHER ITEMS OR FOR LOSS OF USE, REVENUE OR PROFIT OR LOSS OF DATA OR DIMINUTION IN VALUE, OR FOR ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES WHETHER ARISING OUT OF BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE AND WHETHER OR NOT ONPOINT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS ESSENTIAL PURPOSE. IN NO EVENT SHALL ONPOINT'S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THE SERVICES, THE DELIVERABLES AND THIS AGREEMENT, WHETHER ARISING OUT OF OR RELATED TO BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, EXCEED THE AGGREGATE AMOUNTS PAID TO ONPOINT BY CUSTOMER IN THE SIX-MONTH PERIOD IMMEDIATELY PRECEDING THE FIRST EVENT GIVING RISE TO LIABILITY.</p>

                <p>11.	Indemnification. Customer shall indemnify, hold harmless, and, at OnPoint's option, defend OnPoint from and against any and all losses, damages, liabilities, and costs (including reasonable attorney fees) incurred by OnPoint as a result of any claim, suit, action or proceeding based on Customer's or any related person or entity's negligence or willful misconduct, breach of this Agreement, use of any Services or Deliverables in combination with data, software, hardware or technology not provided by OnPoint or modifications to the Services or Deliverables not made by OnPoint.</p>

                <p>12.	Term and Termination. Unless otherwise set forth in the Order Confirmation: (a) the term of this Agreement commences on the date of the Order Confirmation and continues for a period of one (1) month, unless and until earlier terminated as provided under this Agreement (the "Initial Term"); (b) on expiration of the Initial Term, this Agreement automatically renews for additional successive one (1) month terms unless and until either party provides notice of nonrenewal at least five (5) days before the end of the then-current term, or unless and until earlier terminated as provided under this Agreement (each a "Renewal Term" and together with the Initial Term, the "Term"); (c) if the Term is renewed for any Renewal Term(s) pursuant to this Section, the terms and conditions of this Agreement during each such Renewal Term are the same as the terms in effect immediately prior to such renewal; and (d) if either party provides timely notice of its intent not to renew this Agreement, then, unless earlier terminated in accordance with its terms, this Agreement terminates on the expiration of the then-current Term. In addition to any remedies that may be provided under this Agreement, OnPoint may terminate this Agreement with immediate effect upon written notice to Customer, if Customer: (e) fails to pay any amount when due under this Agreement and such failure continues for fifteen (15) days after Customer's receipt of written notice of nonpayment; (f) has not otherwise performed or complied with any of the terms of this Agreement, in whole or in part; or (g) becomes insolvent, files a petition for bankruptcy or commences or has commenced against it proceedings relating to bankruptcy, receivership, reorganization, or assignment for the benefit of creditors. Upon expiration or earlier termination of this Agreement, Customer shall immediately discontinue use of all Services and Deliverables and delete, destroy, or return all copies of OnPoint materials in its possession.</p>

                <p>13.	Waiver. No waiver by OnPoint of any of the provisions of this Agreement is effective unless explicitly set forth in writing and signed by OnPoint. No failure to exercise, or delay in exercising, any rights, remedy, power, or privilege arising from this Agreement operates or may be construed as a waiver thereof. No single or partial exercise of any right, remedy, power, or privilege hereunder precludes any other or further exercise thereof or the exercise of any other right, remedy, power, or privilege.</p>

                <p>14.	Force Majeure. OnPoint shall not be liable or responsible to Customer, nor be deemed to have defaulted or breached this Agreement, for any failure or delay in fulfilling or performing any term of this Agreement when and to the extent such failure or delay is caused by or results from acts or circumstances beyond the reasonable control of OnPoint including, without limitation, Customer's acts or omissions, acts of God, flood, fire, explosion, governmental actions, war, invasion or hostilities, terrorist threats or acts, riot, or other civil unrest, national emergency, revolution, insurrection, epidemic, pandemic, lock-outs, strikes or other labor disputes (whether or not relating to either party's workforce), or restraints or delays affecting carriers or inability or delay in obtaining supplies of adequate or suitable materials, or telecommunication breakdown or power outage.</p>

                <p>15.	Miscellaneous. Customer shall not assign any of its rights or delegate any of its obligations under this Agreement without the prior written consent of OnPoint. Any purported assignment or delegation in violation of this Section is null and void. No assignment or delegation relieves Customer of any of its obligations under this Agreement. The relationship between the parties is that of independent contractors. Nothing contained in this Agreement shall be construed as creating any agency, partnership, joint venture or other form of joint enterprise, employment, or fiduciary relationship between the parties, and neither party shall have authority to contract for or bind the other party in any manner whatsoever. This Agreement is for the sole benefit of the parties hereto and their respective successors and permitted assigns and nothing herein, express or implied, is intended to or shall confer upon any other person or entity any legal or equitable right, benefit or remedy of any nature whatsoever under or by reason of these Terms. All matters arising out of or relating to this Agreement are governed by and construed in accordance with the internal laws of the State of Michigan without giving effect to any choice or conflict of law provision or rule (whether of the State of Michigan or any other jurisdiction) that would cause the application of the laws of any jurisdiction other than those of the State of Michigan. Any legal suit, action, or proceeding arising out of or relating to this Agreement shall be instituted in the federal courts of the United States of America or the courts of the State of Michigan in each case located in Oakland County, and each party irrevocably submits to the exclusive jurisdiction of such courts in any such suit, action, or proceeding. If any term or provision of this Agreement is invalid, illegal, or unenforceable in any jurisdiction, such invalidity, illegality, or unenforceability shall not affect any other term or provision of this Agreement or invalidate or render unenforceable such term or provision in any other jurisdiction. Provisions of these Terms, which by their nature should apply beyond their terms, will remain in force after any termination or expiration of this Agreement including, but not limited to, Limitation of Liability, Confidentiality and Miscellaneous. This Agreement may only be amended or modified in a writing which specifically states that it amends this Agreement and is signed by an authorized representative of each party.</p>
            </Typography>

            <hr />

            <FormControlLabel
                control={ <Checkbox
                            required
                            key='agree_eula'
                            name='agree_eula'
                            checked={acceptedEula}
                            onChange={(e) => setAcceptedEula(e.target.checked)}
                            style={{ transform: "scale(1.25)" }}
                            />  }
                label="Accept the terms and conditions"
            />
        </Box>
    )
}

const Step2 = ({
        acceptedCsp,
        setAcceptedCsp,
    }) => {

    return (
        <Box sx={{ backgroundColor:"white", padding: 3 }}>
            <Typography style={{ fontSize: '1.5em', paddingTop: "1em", marginRight: '1em' }}>
                We're proud to partner with some of the leading manufacturers in the
                industry.
                <br />
                With these partnerships, you'll be able to take advantage of
                exclusive programs and incentives that you won't find anywhere else.
            </Typography>

            <Typography color="textSecondary">
                Please check the box below for more information about Center Store Promotions.
            </Typography>

            <Typography sx={{
                margin: '1em 0',
                maxHeight: "50vh",         // Limit height
                overflowY: 'auto',      // Enable vertical scroll
                paddingRight: 2,        // Optional: spacing for scrollbar
            }}>
                <h2>ONPOINT PROMOTIONS (CENTER STORE PROMOTIONS)</h2>
                
                <p>
                    OnPoint and WAM Distributors partner to deliver exclusive, brand-funded promotional programs from top, leading manufacturers directly to your store.
                    Through OnPoint enrollment, retailers can gain access to a year-round calendar of promotions from national brands including Conagra, Ferrara, Ferrero, General Mills, Hormel , Fiji Water, J.M. Smicker, Kellanova, KIND, Kraft Heinz, Mars Wrigley, Mondelēz, Perfetti Van Melle, Simply Beverages, Simply Good Foods, and more.
                </p>
                
                <h3>How It Works</h3>
                
                <p>Retailers can participate in up to 68 promotional opportunities per year, organized into “waves” of two months,  featuring anywhere between 7-13 deals at a time! Participation is flexible and retailers choose the promotions that best align with their goals and may opt out at any time. The deal is set up in the eligible point-of-sale (POS) system / or 3rd party price book and the promotional tag is tracked and monitored via OnPoint’s secure scan-data transaction collector. Each valid scanned “amount off” discount is reimbursed, ensuring you do not absorb the cost of the promotion while driving incremental sales.</p>
                
                <h3>Upon enrollment, retailers receive:</h3>
                <ul>
                    <li>A complimentary signage kit</li>
                    <li>Access to digital advertising for the promotions</li>
                    <li>Ongoing and timely support from the OnPoint Promotions team</li>
                    <li>Execution guidance and program resources</li>
                </ul>

                <h3>Why Retailers Participate</h3>
                <ul>
                    <li>Offer nationally recognized brand promotions in your store</li>
                    <li>Drive repeat traffic</li>
                    <li>Increase product movement</li>
                    <li>Participate in a no-cost program designed to generate incremental sales</li>
                </ul>
                
                <b>If you’re ready to implement a turnkey program designed for independent stores and small chains, OnPoint Center Store Promotions is ready to support your growth. Check the box below to begin the enrollment process.</b>
            </Typography>
            
            <hr />
            
            <Alert severity='info'>
                After successfully installing the transaction collector, you will then receive an email invitation from the OnPoint Promotions team to confirm your enrollment with Center Store Promotions. The email will contain step-by-step instructions on how to activate your official enrollment, enabling you to participate.
            </Alert>

            <FormGroup>
                <FormControlLabel
                    control={ <Checkbox
                                key='accepted_center_store_participation'
                                name='accepted_center_store_participation'
                                checked={acceptedCsp}
                                onChange={(e) => setAcceptedCsp(e.target.checked)}
                                style={{ transform: "scale(1.25)" }}
                                />  }
                    label="I'd like to start the enrollment process for Center Store Promotions"
                />
            </FormGroup>
        </Box>
    )
}

const Step3 = ({
        acceptedPatronPoints,
        setAcceptedPatronPoints,
    }) => {

    return (
        <Box sx={{ backgroundColor:"white", padding: 3 }}>
            <Typography>
                Please check the box below to be contacted about Patron Points Tobacco Scan Data & Loyalty.
            </Typography>

            <Typography sx={{
                margin: '1em 0',
                maxHeight: "50vh",         // Limit height
                overflowY: 'auto',      // Enable vertical scroll
                paddingRight: 2,        // Optional: spacing for scrollbar
            }}>
                <h2>WHAT IS PATRON POINTS? </h2>

                <p>Patron Points is a proud provider of customizable customer loyalty solutions for businesses and retailers within the convenience store industry. With more than 17 years of experience in delivering top-notch customer loyalty, mobile App solutions, and other customer retention tools, we're constantly striving to ensure that today's businesses have the tools that they need to keep the customers that they already have, while seamlessly acquiring new ones.</p>

                <p>We're firm believers that the customer relationship strategy that a business employs needs to take into account the current interests of the consumer. Through our use of technology, we provide businesses with the digital tools needed to maintain positive customer relationships with their target audiences.</p>

                <p>Today, the Patron Points loyalty platform, customizable mobile app, tobacco scan data and loyalty, along with our other services remains firm in our goal to help all convenience store operators achieve maximum profits through customer loyalty participation. For years, this principle has held true no matter the size, scale, or scope of our clients' businesses.</p>
            </Typography>

            <hr />

            <Alert severity="info"><b>Limited time offer!</b> If you successfully install with the Onpoint Scan Data Sharing Program before June 30, 2026, you will be eligible for a free 6 months of Patron Points Tobacco Scan Data & Loyalty.</Alert>

            <FormGroup>
                <FormControlLabel
                    control={ <Checkbox
                                key='interested_in_patron_points_tobacco'
                                name='interested_in_patron_points_tobacco'
                                checked={acceptedPatronPoints}
                                onChange={(e) => setAcceptedPatronPoints(e.target.checked)}
                                style={{ transform: "scale(1.25)" }}
                                />  }
                    label="I'm also interested in Patron Points Tobacco Promotions"
                />
            </FormGroup>
        </Box>
    )
}

const Step4 = ({
        acceptedEula,
        acceptedCsp,
        acceptedPatronPoints,
        storeDetail,
        submitted,
        setSubmitted,
        onpointInviteToken
    }) => {

    const boxStyles = {
        display: 'flex',
        flexDirection: 'row',
        gap: '1em'
    }

    const notify = useNotify();

    const storeUpdate = {
        accepted_center_store_participation: acceptedCsp,
        accepted_eula: acceptedEula,
        interested_in_patron_points_tobacco: acceptedPatronPoints
      }

    const handleSubmit = () => {
        fetch(`${API_ROOT}/rpc/extraction_registration_results`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Prefer: "params=single-object",
          },
          body: JSON.stringify({
            results: storeUpdate,
            token: onpointInviteToken,
          }),
        })
          .then(async (response) => {
            if (!response.ok) {
              const errorText = await response.text();
              throw new Error(errorText);
            }
            return response.json();
          })
          .then((data) => {
            notify("OnPoint Registration Complete", { type: "info" });
            setSubmitted(true);
          })
          .catch((error) => {
            console.error("Registration error:", error);
            notify("Registration Request Error", { type: "warning" });
          });
      };

    return (
        <Box sx={{ textAlign: 'center', backgroundColor:"white", padding: 3  }} >
            <Typography>
                 Please review and submit your registration for:
            </Typography>

            <Card sx={{ display: 'inline-block' }}>
                <CardHeader title={storeDetail?.store_name} />

                <CardContent>
                    <Typography>
                        <b>Contact Person:</b> {storeDetail?.contact_name}
                        <br />
                        <b>Address: </b>
                        {storeDetail?.store_address_1 ? storeDetail?.store_address_1 : ""}&nbsp;
                        {storeDetail?.store_address_2 ? storeDetail?.store_address_2 : ""}&nbsp;
                        {storeDetail?.store_city} {storeDetail?.store_state}&nbsp;
                        {storeDetail?.store_zip}
                    </Typography>

                    <hr />

                    <Container sx={{ padding: '1em' }}>
                        <Box sx={boxStyles}>
                            <span>{acceptedEula ? <CheckCircle style={{color: "#0b6623"}} /> : <Close style={{color: "DarkRed"}}/>}</span>
                            <Typography>Accepted Terms and Services</Typography>
                        </Box>

                        <Box sx={boxStyles}>
                            <span>{acceptedCsp ? <CheckCircle style={{color: "#0b6623"}} /> : <Close style={{color: "DarkRed"}}/>}</span>
                            <Typography>Accepted Center Store Participation</Typography>
                        </Box>

                        <Box sx={boxStyles}>
                            <span>{acceptedPatronPoints ? <CheckCircle style={{color: "#0b6623"}} /> : <Close style={{color: "DarkRed"}}/>}</span>
                            <Typography>Interested in Patron Points Tobacco Program</Typography>
                        </Box>
                        {!submitted ? (
                            <Box>
                                <Button 
                                    variant="contained" 
                                    onClick={handleSubmit} 
                                    label={"Submit Registration"}>
                                        <PublishIcon/>
                                </Button>
                                    
                            </Box>
                        ) : (
                            <Box sx={boxStyles}>
                                <span>{submitted ? <CheckCircle style={{color: "#0b6623"}} /> : <Close style={{color: "DarkRed"}}/>}</span>
                                <Typography>Registration Submitted! - Please continue to install the software</Typography>
                            </Box>
                        )}
                    </Container>
                </CardContent>
            </Card>
        </Box>
    )
}

const Step5 = () => {
    return (
        <Box sx={{ backgroundColor:"white", padding: 3 }}>
            <Typography style={{ paddingTop: "1em" }}>
                <h2>PREINSTALLATION CHECKLIST</h2>

                <Alert severity='warning'>
                    IMPORTANT: Once you have downloaded the transaction collector and begun the installation, you will see the following screen:
                    <hr />
                    <img alt="Preinstallation Checklist Link" src={PreinstallationChecklistLink} width="600px" />
                    <hr />
                    You MUST click the blue text, highlighted in this image in the red box, that reads "click here to review preinstallation checklist before continuing."
                    <br />
                    <b>If you do not follow the preinstallation instructions, the Transaction Collector installation will fail.</b>
                </Alert>
            </Typography>
        </Box>
    )
}

const Step6 = () => {

    return (
        <Box sx={{ textAlign: 'center', backgroundColor:"white", padding: 3  }}>
            <Typography variant="h5">
                Almost there:
            </Typography>

            <Typography>
                I'm ready to download the software.
            </Typography>
            
            <Button
                startIcon={<CloudDownloadIcon />}
                variant="contained"
                color="primary"
                href="https://tcapi.prod.patronpoints.com/TransactionCollectorInstaller.exe"
                sx={{ marginTop: '.5em' }}
                label="Click Here to Download"
            />
        </Box>
    )
}

const SignupWizardToolbar = ({acceptedTerms, submitted}) => {
    const {
        hasNextStep,
        hasPreviousStep,
        goToNextStep,
        goToPreviousStep,
        currentStep
    } = useWizardFormContext();

    const { save } = useSaveContext();
    const { isValidating } = useFormState();
    const isStep4 = currentStep === 3; // 0-based index

    const buttonStyles = {
        padding: '1em'
    }

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            gap: '1em', 
            padding: '1em'
        }}>
            {hasPreviousStep && goToPreviousStep && (
                <Button
                    variant="outlined"
                    onClick={() => goToPreviousStep()}
                    sx={{padding: '1em', backgroundColor:"white"}}
                >
                    ← BACK
                </Button>
            )}
            {hasNextStep && goToNextStep ? (
                <Button
                    variant="contained"
                    disabled={isValidating || !acceptedTerms || (isStep4 && !submitted)}
                    onClick={() => goToNextStep()}
                    sx={buttonStyles}
                >
                    NEXT →
                </Button>
            ) : (
                <Button
                    variant="contained"
                    disabled={true}
                    onClick={save}
                    sx={buttonStyles}
                    label={"Process Complete"}
                >
                </Button>
            )}
        </Box>
    );
};

const PatronPointsUserRegistration = () => {
    const [acceptedEula, setAcceptedEula] = useState(false);
    const [acceptedCsp, setAcceptedCsp] = useState(false);
    const [acceptedPatronPoints, setAcceptedPatronPoints] = useState(false);
    const [submitted, setSubmitted] = useState(false)

    const [, setIsValidStore] = useState(false);
    const [storeDetail, setStoreDetail] = useState({
        store_name: "",
        contact_name: "",
        store_address_1: "",
        store_address_2: "",
        store_city: "",
        store_state: "",
        store_zip: "",
    });
    const onpointInviteToken = window.location.hash.split("=")[1];
    
    useEffect(() => { // fill out storeDetail
    
        fetch(`${API_ROOT}/rpc/extraction_token_detail`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: onpointInviteToken,
          }),
        })
          .then((e) => e.json())
          .then((data) => {
    
            const { store_name } = data;
            if (store_name && store_name.length !== 0) {
              setStoreDetail(data);
              setIsValidStore(true);
            }

          })
    }, [onpointInviteToken]);
        
    if (!onpointInviteToken) {
        return <div>Loading...</div>;
    }

    return (
        <ResourceContextProvider value="extraction_software_registration" >
            <Box sx={{ 
                backgroundColor:"#1f77b4", 
                padding: 3, 
                minHeight: '100vh', 
                width: '100%',
                '& .MuiStepLabel-label': {
                    color: 'white',
                },
                '& .MuiStepLabel-label.Mui-active': {
                    color: 'white',
                },
                '& .MuiStepLabel-label.Mui-completed': {
                    color: 'white',
                },
                '& .MuiStepIcon-root.Mui-completed': {
                    color: '#D2DE31'
                },
                '& .MuiStepIcon-root.Mui-active': {
                    color: '#758CA7'
                }
            }}>
                <WizardForm toolbar={<SignupWizardToolbar acceptedTerms={acceptedEula} submitted={submitted} />}>
                    <WizardForm.Step label="Terms and Conditions">
                        <Step1 acceptedEula={acceptedEula} setAcceptedEula={setAcceptedEula} />
                    </WizardForm.Step>
                    <WizardForm.Step label="Center Store Participation">
                        <Step2 acceptedCsp={acceptedCsp} setAcceptedCsp={setAcceptedCsp} />
                    </WizardForm.Step>
                    <WizardForm.Step label="Patron Point Tobacco">
                        <Step3 acceptedPatronPoints={acceptedPatronPoints} setAcceptedPatronPoints={setAcceptedPatronPoints} />
                    </WizardForm.Step>
                    <WizardForm.Step label="Review">
                        <Step4
                            acceptedEula={acceptedEula}
                            acceptedCsp={acceptedCsp}
                            acceptedPatronPoints={acceptedPatronPoints}
                            storeDetail={storeDetail}
                            submitted={submitted}
                            setSubmitted={setSubmitted}
                            onpointInviteToken={onpointInviteToken}
                        />
                    </WizardForm.Step>
                    <WizardForm.Step label="Preinstallation Checklist">
                        <Step5/>
                    </WizardForm.Step>
                    <WizardForm.Step label="Install">
                        <Step6/>
                    </WizardForm.Step>
                </WizardForm>
            </Box>
        </ResourceContextProvider>
    )
};

export default PatronPointsUserRegistration;